export const feiertagsdynamik = {
  KEINE: 'KEINE',
  AUF_SOLL_AUFFUELLEN: 'AUF_SOLL_AUFFUELLEN',
} as const;

export type FeiertagsDynamik = keyof typeof feiertagsdynamik;

export const feiertagsausgleich = {
  KEINER: 'KEINER',
  STUNDENGUTSCHRIFT: 'STUNDENGUTSCHRIFT',
  ZUSCHLAEGE: 'ZUSCHLAEGE',
} as const;

export type Feiertagsausgleich = keyof typeof feiertagsausgleich;
